import Grid from "@mui/material/Grid/Grid";
import {
    CustomLabelMediumSmallBold,
    CustomLabelSmallMedium,
    CustomLabelSmallRegular, CustomLabelXSmallBold,
    CustomLabelXSmallRegular
} from "../common/CustomLabel";
import XMARK from "../../assets/images/xmark.png";
import Stack from "@mui/material/Stack/Stack";
import LinearProgress from "@mui/material/LinearProgress/LinearProgress";
import Box from "@mui/material/Box/Box";
import {CustomTextField, CustomTextMultipleField} from "../common/text";
import InputAdornment from "@mui/material/InputAdornment/InputAdornment";
import USER from "../../assets/images/user.png";
import MAIL_BLACK from "../../assets/images/mail-black.png";
import ARROW_RIGHT_WITHOUT_BORDER from "../../assets/images/arrow-right-without-border.png";
import Paper from "@mui/material/Paper/Paper";
import {CustomDropdown} from "../common/CustomDrowDown";
import ARROR_LEFT from "../../assets/images/arrow-left.png";
import TICK from "../../assets/images/tick.png";
import React, {useState} from "react";
import {useMediaQuery} from "@mui/material";
import MenuItem from "@mui/material/MenuItem/MenuItem";
import createTheme from "@mui/material/styles/createTheme";
import { CustomFileUpload } from "../common/CustomFileUpload";
import Slider from "@mui/material/Slider";

import LIGHT_BULB from "../../assets/images/light-bulb-on.png";
import DESIGN_NIB from "../../assets/images/design-nib.png";
import {transformValidateObject, 
    // validateUserInput
} from "../../utils";

import {collection, addDoc} from "firebase/firestore";
import {db} from "src/firebase/firebaseConfig";
import Loader from "../common/Loader";
import { FormHelperText } from '@mui/material';
// import CLOCK_RIGHT from "../../assets/images/clock-rotate-right.png";
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { storage } from 'src/firebase/firebaseConfig'; // Make sure this is imported


const theme = createTheme({
    breakpoints: {
        values: {
            xs: 0,
            sm: 710,
            md: 950,
            lg: 1300,
            xl: 1350,
        },
    },
});


const initialStep1Data = {
    full_name: {value: '', showError: false, error: 'Field cant be empty'},
    email: {value: '', showError: false, error: 'Field cant be empty'},
    project_title: {value: '', showError: false, error: 'Field cant be empty'},
    project_description: {value: '', showError: false, error: 'Field cant be empty'},

}


const initialStep2Data = {
    initial_fund: {value: '', showError: false, error: 'Please select inital investment or fund'},
    investment_model: {value: '', showError: false, error: 'Please select an investment model'},
    project_standing: {value: 'idea', showError: false, error: 'Please select a project stage'},
}


const initialStep3Data = {
    // For Idea stage
    idea_description: {value: '', showError: false, error: 'Field cant be empty'},
    industry: {value: '', showError: false, error: 'Please select an industry'},
    
    // For Wireframes stage
    wireframes_file: {value: null, showError: false, error: 'Please upload wireframes'},
    creator: {value: '', showError: false, error: 'Please select creator'},
    features_description: {value: '', showError: false, error: 'Field cant be empty'},
    
    // For Prototype stage
    prototype_access: {value: null, showError: false, error: 'Please provide prototype access'},
    prototype_creator: {value: '', showError: false, error: 'Please select creator'},
    tech_used_prototype: {value: '', showError: false, error: 'Please select tech'},
    
    // For MVP stage
    mvp_access: {value: null, showError: false, error: 'Please provide MVP access'},
    user_tested_mvp: {value: 10, showError: false, error: 'Please specify user count'},
    user_feedback: {value: null, showError: false, error: 'Please upload user feedback'},
    // equity_willing_for_perc: {value: '', showError: false, error: 'Please choose range'},
    
    // For Development stage
    development_project_access: {value: null, showError: false, error: 'Please provide development access'},
    team_description: {value: '', showError: false, error: 'Field cant be empty'},
    //features_description
    
    // For Launched stage
    live_product_link: {value: '', showError: false, error: 'Please provide product link'},
    active_users_percentage: {value: 100, showError: false, error: 'Please specify active users percentage'},
    monthly_revenue_percentage: {value: 1000, showError: false, error: 'Please specify monthly revenue percentage'},
    need_support: {value: '', showError: false, error: 'Please select an option'},
    has_investors: {value: '', showError: false, error: 'Please select an option'},
    
    // Common fields
    tech_stack: {value: [], showError: false, error: 'Field cant be empty'},
    additional_info: {value: '', showError: false, error: 'Field cant be empty'}
}

const initialStep4Data = {
    user_tested_mvp: {value: 10, showError: false, error: 'Please specify user count'},

    // Common fields for all stages
    equity_percentage: {value: 1, showError: false, error: 'Please specify equity percentage'},
    tech_stack: {value: '', showError: false, error: 'Please select tech stack'},
    
    // For Idea stage
    market_research: {value: '', showError: false, error: 'Please select an option'},
    competitor_analysis: {value: '', showError: false, error: 'Please select an option'},
    willing_equity: {value: '', showError: false, error: 'Please select an option'},
    equity_willing_for_perc: {value: '', showError: false, error: 'Please choose range'},
    
    // For Wireframes stage
    technical_cofounder: {value: '', showError: false, error: 'Please select an option'},
    user_testing: {value: '', showError: false, error: 'Please select an option'},
    //tech_stack
    //equity_willing_for_perc
    
    // For Prototype stage
    user_feedback: {value: '', showError: false, error: 'Please select an option'},
    road_map_after_prototype: {value: '', showError: false, error: 'Please select an option'},
    // technical_cofounder
    // tech_stack
    pitched_investors: {value: '', showError: false, error: 'Please select an option'},
    // equity_willing_for_perc
    
    // For MVP stage
    technical_challenges: {value: '', showError: false, error: 'Please select challenges'},
    //tech_stack
    //technical_cofounder
    pitched_prototype_to_investors: {value: '', showError: false, error: 'Please select an option'},
    //equity_willing_for_perc
    
    // For Development stage
    generating_revenue: {value: '', showError: false, error: 'Please select an option'},
    
    // For Launched stage
    active_users_percentage: {value: 1, showError: false, error: 'Please specify active users percentage'},
    monthly_revenue_percentage: {value: 1, showError: false, error: 'Please specify monthly revenue percentage'},
    need_support: {value: '', showError: false, error: 'Please select an option'},
    has_investors: {value: '', showError: false, error: 'Please select an option'}
}

const initialStep5Data = {
    tech_stack: {value: '', showError: false, error: 'Please select tech stack'},
    next_steps: {value: '', showError: false, error: 'Field cant be empty'},
    additional_info: {value: '', showError: false, error: 'Field cant be empty'},
}
const IndustryistContainer = [
    "Technology",
    "Healthcare",
    "Finance",
    "Education",
    "E-commerce",
    "Other"
  ].map((list) => (
    <MenuItem value={list}>
      <CustomLabelSmallRegular text={list} />
    </MenuItem>
  ));
const TechStackList = [
   "React",
    "Angular",
    "Laravel",
    "Vue.js",
    "Node.js",
    "Django",
    "Flask",
    "Ruby on Rails"
  ].map((list) => (
    <MenuItem value={list}>
      <CustomLabelSmallRegular text={list} />
    </MenuItem>
  ));
const WireframesCreatorList = [
"Self", "Freelancer", "Designer", "Other"
  ].map((list) => (
    <MenuItem value={list}>
      <CustomLabelSmallRegular text={list} />
    </MenuItem>
  ));
const PrototypeTechList = [
"Figma", "Adobe XD", "Sketch", "Other"
  ].map((list) => (
    <MenuItem value={list}>
      <CustomLabelSmallRegular text={list} />
    </MenuItem>
  ));
const RoadmapList = [
"Build MVP",
"Secure Funding",
"Scale Users",
"Monetization",
"Market Expansion"
].map((list) => (
    <MenuItem value={list}>
      <CustomLabelSmallRegular text={list} />
    </MenuItem>
  ));

const TechChallengeList = [
    "Scalability",
    "User Acquisition",
    "Monetization",
    "Market Expansion"
  ].map((list) => (
    <MenuItem value={list}>
        <CustomLabelSmallRegular text={list} />
    </MenuItem>
  ));
  
const ProjectByEquity = ({
                             setShowProjectByEquity,
                             setShowConfirmation
                         }) => {

    // const [isMenuClicked, setIsMenuClicked] = useState(false)

    const [progress, setProgress] = useState(5);
    const [currentStage, setCurrentStage] = useState('');

    const [step1, setStep1] = useState(initialStep1Data);
    const [step2, setStep2] = useState(initialStep2Data);
    const [step3, setStep3] = useState(initialStep3Data);
    const [step4, setStep4] = useState(initialStep4Data);
    const [step5, setStep5] = useState(initialStep5Data);


    const [isLoading, setIsLoading] = useState(false);
    // const [count, setCount] = useState(0);


    const saveProject = async (database, data) => {
        try {
            // Create a copy of data to modify
            const processedData = { ...data };
            
            // Handle file uploads
            const fileFields = [
                'wireframes_file',
                'user_feedback',
                'prototype_access',
                'mvp_access',
                'development_project_access'
            ];

            // Process all file fields
            for (const field of fileFields) {
                if (processedData[field] && processedData[field] instanceof File) {
                    // Create a reference to storage
                    const fileRef = ref(storage, `project-by-equity-files/${Date.now()}-${processedData[field].name}`);
                    
                    // Upload the file
                    await uploadBytes(fileRef, processedData[field]);
                    
                    // Get the download URL
                    const downloadURL = await getDownloadURL(fileRef);
                    
                    // Replace the file object with the download URL in the data
                    processedData[field] = downloadURL;
                }
            }

            // Add the processed data to Firestore
            await addDoc(collection(db, database), {
                ...processedData,
                createdAt: new Date()
            });

        } catch (error) {
            console.error('Error saving project:', error);
            throw error; // Re-throw the error so it can be handled by the calling function
        }
    };

    const onChangeStep1 = (e, type) => {
        let data;
        let value = e.target.value


        data = {...step1, [type]: {...step1[type], value: value}};
        setStep1(data);
    }


    const onChangeStep2 = (e, type) => {
        let data;
        let value = e.target.value


        data = {...step2, [type]: {...step2[type], value: value}};
        setStep2(data);
    }


    const onChangeStep3 = (e, type) => {
        let data;
        let value = e.target.value
        data = {...step3, [type]: {...step3[type], value: value}};
        setStep3(data);
    };

    const onSubmitStep1 = (e) => {
        let hasError = false;
        const updatedStep1 = { ...step1 };
        
        // Validate each field
        Object.keys(step1).forEach(field => {
            if (!step1[field].value || step1[field].value.trim() === '') {
                updatedStep1[field] = {
                    ...step1[field],
                    showError: true,
                    error: 'Field cannot be empty'
                };
                hasError = true;
            } else {
                updatedStep1[field] = {
                    ...step1[field],
                    showError: false,
                    error: ''
                };
            }
            
            // Additional email validation
            if (field === 'email' && !hasError) {
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailRegex.test(step1[field].value)) {
                    updatedStep1[field] = {
                        ...step1[field],
                        showError: true,
                        error: 'Please enter a valid email address'
                    };
                    hasError = true;
                }
            }
        });

        setStep1(updatedStep1);
        
        if (!hasError) {
            setProgress(25);
        }
    }


    const onSubmitStep2 = (e) => {
        let hasError = false;
        const updatedStep2 = { ...step2 };
        
        // Validate initial fund
        if (!step2.initial_fund.value) {
            updatedStep2.initial_fund = {
                ...step2.initial_fund,
                showError: true,
                error: 'Please select initial investment or fund'
            };
            hasError = true;
        } else {
            updatedStep2.initial_fund = {
                ...step2.initial_fund,
                showError: false,
                error: ''
            };
        }

        // Validate investment model
        if (!step2.investment_model.value) {
            updatedStep2.investment_model = {
                ...step2.investment_model,
                showError: true,
                error: 'Please select an investment model'
            };
            hasError = true;
        } else {
            updatedStep2.investment_model = {
                ...step2.investment_model,
                showError: false,
                error: ''
            };
        }

        // Validate project standing
        if (!step2.project_standing.value) {
            updatedStep2.project_standing = {
                ...step2.project_standing,
                showError: true,
                error: 'Please select a project stage'
            };
            hasError = true;
        } else {
            updatedStep2.project_standing = {
                ...step2.project_standing,
                showError: false,
                error: ''
            };
        }

        setStep2(updatedStep2);
        
        if (!hasError) {
            setProgress(45);
            setCurrentStage(step2.project_standing.value);
        }
    }


    const onSubmitStep3 = (e) => {
        const getRelevantFields = () => {
            // const commonFields = {
            //     tech_stack: step3.tech_stack,
            //     additional_info: step3.additional_info
            // };

            switch(step2.project_standing.value) {
                case 'idea':
                    return {
                        idea_description: step3.idea_description,
                        industry: step3.industry,
                        // ...commonFields
                    };
                
                case 'wireframes':
                    return {
                        wireframes_file: step3.wireframes_file,
                        creator: step3.creator,
                        features_description: step3.features_description,
                        // ...commonFields
                    };
                
                case 'prototype':
                    return {
                        prototype_access: step3.prototype_access,
                        prototype_creator: step3.prototype_creator,
                        tech_used_prototype :step3.tech_used_prototype,
                        features_description: step3.features_description,
                        // ...commonFields
                    };
                
                case 'mvp':
                    return {
                        mvp_access: step3.mvp_access,
                        user_tested_mvp: step3.user_tested_mvp,
                        user_feedback: step3.user_feedback,
                        features_description: step3.features_description,
                        // ...commonFields
                    };
                
                case 'development':
                    return {
                        development_project_access: step3.development_project_access,
                        team_description: step3.team_description,
                        features_description: step3.features_description,
                        // ...commonFields
                    };
                
                case 'launched':
                    return {
                        live_product_link: step3.live_product_link,
                        active_users_percentage: step3.active_users_percentage,
                        monthly_revenue_percentage: step3.monthly_revenue_percentage,
                        features_description: step3.features_description,
                        // ...commonFields
                    };
                
                default:
                    // return commonFields;
                    return{
                        idea_description: step3.idea_description,
                        industry: step3.industry,
                    }
            }
        };

        const relevantData = getRelevantFields();
        console.log('step3 relevant fields:', relevantData);
        
        // Validate only the relevant fields
        // const validate = validateUserInput(relevantData);
        // if (validate.isValid) {
            setProgress(70);
        // } else {
            // Update only the relevant fields that have errors
            // const updatedStep3 = {...step3};
            // Object.keys(validate.data).forEach(key => {
                // updatedStep3[key] = validate.data[key];
            // });
            // setStep3(updatedStep3);
        // }
    }

    const onSubmitStep4 = (e) => {
        console.log('step4', step4);

        const getRelevantFields = () => {

            switch(step2.project_standing.value) {
                case 'idea':
                    return {
                        market_research: step4.market_research,
                        competitor_analysis: step4.competitor_analysis,
                        willing_equity: step4.willing_equity,
                        equity_willing_for_perc: step4.equity_willing_for_perc,
                    };
                
                case 'wireframes':
                    return {
                        technical_cofounder: step4.technical_cofounder,
                        user_testing: step4.user_testing,
                        tech_stack: step4.tech_stack,
                        equity_willing_for_perc: step4.equity_willing_for_perc,
                    };
                
                case 'prototype':
                    return {
                        user_feedback: step4.user_feedback,
                        road_map_after_prototype: step4.road_map_after_prototype,
                        technical_cofounder: step4.technical_cofounder,
                        tech_stack: step4.tech_stack,
                        pitched_investors: step4.pitched_investors,
                        equity_willing_for_perc: step4.equity_willing_for_perc,
                    };
                
                case 'mvp':
                    return {
                        technical_challenges: step4.technical_challenges,
                        technical_cofounder: step4.technical_cofounder,
                        tech_stack: step4.tech_stack,
                        pitched_prototype_to_investors: step4.pitched_prototype_to_investors,
                        equity_willing_for_perc: step4.equity_willing_for_perc,
                    };
                
                case 'development':
                    return {
                        technical_challenges: step4.technical_challenges,
                        tech_stack: step4.tech_stack,
                        technical_cofounder: step4.technical_cofounder,
                        generating_revenue: step4.generating_revenue,
                        pitched_prototype_to_investors: step4.pitched_prototype_to_investors,
                        equity_willing_for_perc: step4.equity_willing_for_perc,
                    };
                
                case 'launched':
                    return {
                        technical_challenges: step4.technical_challenges,
                        need_support: step4.need_support,
                        tech_stack: step4.tech_stack,
                        has_investors: step4.has_investors,
                        equity_willing_for_perc: step4.equity_willing_for_perc,
                    };
                
                default:
                    return{
                        market_research: step4.market_research,
                        competitor_analysis: step4.competitor_analysis,
                        equity_willing_for_perc: step4.equity_willing_for_perc,
                    }
            }
        };

        const relevantData = getRelevantFields();
        console.log('step4 relevant fields:', relevantData);
        
        // const validate = validateUserInput(step4);
        // if (validate.isValid) {
            setProgress(95);
        // } else {
            // Update only the relevant fields that have errors
            // const updatedStep4 = {...step4};
            // Object.keys(validate.data).forEach(key => {
                // updatedStep4[key] = validate.data[key];
            // });
            // setStep4(updatedStep4);
        // }
    }

    const onSubmitStep5 = async (e) => {
        // Get common fields that are always needed
        const commonFields = {
            ...transformValidateObject({
                full_name: step1.full_name,
                email: step1.email,
                project_title: step1.project_title,
                project_description: step1.project_description
            }),
            ...transformValidateObject({
                initial_fund: step2.initial_fund,
                investment_model: step2.investment_model,
                project_standing: step2.project_standing
            })
        };

        // Get stage-specific fields
        const getStageSpecificFields = () => {
            switch(step2.project_standing.value) {
                case 'idea':
                    return {
                        ...transformValidateObject({
                            idea_description: step3.idea_description,
                            industry: step3.industry
                        }),
                        ...transformValidateObject({
                            market_research: step4.market_research,
                            competitor_analysis: step4.competitor_analysis,
                            willing_equity: step4.willing_equity,
                            equity_willing_for_perc: step4.equity_willing_for_perc
                        }),
                        ...transformValidateObject({
                            tech_stack: step5.tech_stack
                        })
                    };

                case 'wireframes':
                    return {
                        ...transformValidateObject({
                            wireframes_file: step3.wireframes_file,
                            creator: step3.creator,
                            features_description: step3.features_description
                        }),
                        ...transformValidateObject({
                            technical_cofounder: step4.technical_cofounder,
                            user_testing: step4.user_testing,
                            equity_percentage: step4.equity_percentage
                        }),
                        ...transformValidateObject({
                            next_steps: step5.next_steps,
                        })
                    };

                case 'prototype':
                    return {
                        ...transformValidateObject({
                            prototype_access: step3.prototype_access,
                            prototype_creator: step3.prototype_creator
                        }),
                        ...transformValidateObject({
                            user_feedback: step4.user_feedback,
                            road_map_after_prototype: step4.road_map_after_prototype,
                            technical_cofounder: step4.technical_cofounder,
                            pitched_investors: step4.pitched_investors,
                            equity_willing_for_perc: step4.equity_willing_for_perc,
                            tech_stack: step4.tech_stack
                        }),
                        ...transformValidateObject({
                            next_steps: step5.next_steps,
                        })
                    };

                case 'mvp':
                    return {
                        ...transformValidateObject({
                            mvp_access: step3.mvp_access,
                            user_tested_mvp: step3.user_tested_mvp,
                            user_feedback: step3.user_feedback,
                            features_description: step3.features_description
                        }),
                        ...transformValidateObject({
                            technical_challenges: step4.technical_challenges,
                            technical_cofounder: step4.technical_cofounder,
                            pitched_prototype_to_investors: step4.pitched_prototype_to_investors,
                            equity_willing_for_perc: step4.equity_willing_for_perc,
                            tech_stack: step4.tech_stack
                        }),
                        ...transformValidateObject({
                            next_steps: step5.next_steps,
                        })
                    };

                case 'development':
                    return {
                        ...transformValidateObject({
                            development_project_access: step3.development_project_access,
                            team_description: step3.team_description,
                            features_description: step3.features_description
                        }),
                        ...transformValidateObject({
                            generating_revenue: step4.generating_revenue,
                            technical_challenges: step4.technical_challenges,
                            technical_cofounder: step4.technical_cofounder,
                            pitched_prototype_to_investors: step4.pitched_prototype_to_investors,
                            equity_willing_for_perc: step4.equity_willing_for_perc,
                            tech_stack: step4.tech_stack
                        }),
                        ...transformValidateObject({
                            next_steps: step5.next_steps,
                        })
                    };

                case 'launched':
                    return {
                        ...transformValidateObject({
                            live_product_link: step3.live_product_link,
                            active_users_percentage: step3.active_users_percentage,
                            monthly_revenue_percentage: step3.monthly_revenue_percentage,
                            features_description: step3.features_description
                        }),
                        ...transformValidateObject({
                            technical_challenges: step4.technical_challenges,
                            tech_stack: step4.tech_stack,
                            need_support: step4.need_support,
                            has_investors: step4.has_investors,
                            equity_willing_for_perc: step4.equity_willing_for_perc,
                        }),
                        ...transformValidateObject({
                            next_steps: step5.next_steps,
                        })
                    };

                default:
                    return {};
            }
        };

        // Final data object with common and stage-specific fields
        const data = {
            ...commonFields,
            ...getStageSpecificFields(),
            ...transformValidateObject({
                additional_info: step5.additional_info
            })
        };

            console.log('step5', data);
            setIsLoading(true);
            await saveProject("project-by-equity", data);
            setShowProjectByEquity(false);
            setShowConfirmation(true);
    };

    const onChangeStep4 = (e, type) => {
        let data;
        let value = e.target.value;
        data = {...step4, [type]: {...step4[type], value: value}};
        setStep4(data);
    }

    const onChangeStep5 = (e, type) => {
        let data;
        let value = e.target.value;
        data = {...step5, [type]: {...step5[type], value: value}};
        setStep5(data);
    }

    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));


    // const steps = ['Basic Info', 'Developer Requirements', 'Addtional Details'];


    // const DeveloperStackListContainer = [
    //     "MERN (MongoDB, Express.js, React, Node.js)",
    //     "MEAN (MongoDB, Express.js, Angular, Node.js)",
    //     "LAMP (Linux, Apache, MySQL, PHP)",
    //     "LEMP (Linux, Nginx, MySQL, PHP)",
    //     "JAMstack (JavaScript, APIs, Markup)",
    //     "Django + PostgreSQL + Nginx",
    //     "Ruby on Rails + PostgreSQL",
    //     "Spring Boot + React + MySQL"
    // ].map((list) =>
    //     <MenuItem value={list}><CustomLabelSmallRegular text={list}/></MenuItem>)
    const handleClickOutside = (e) => {
        if (e.target === e.currentTarget) {
            setShowProjectByEquity(false);
        }
    };

    const Wireframe = () => {
        return(
            <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 32.02L8.02 31.9978" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M8 40.02L8.02 39.9978" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M8 16.02L8.02 15.9978" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M8 8.02L8.02 7.99778" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M8 24.02L8.02 23.9978" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M16 40.02L16.02 39.9978" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M24 40.02L24.02 39.9978" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M32 40.02L32.02 39.9978" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M40 40.02L40.02 39.9978" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M40 32.02L40.02 31.9978" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M40 24.02L40.02 23.9978" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M40 16.02L40.02 15.9978" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M40 8.02L40.02 7.99778" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M32 8.02L32.02 7.99778" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M24 8.02L24.02 7.99778" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M16 8.02L16.02 7.99778" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M16 32V16H32V32H16Z" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        )
    }
    const Mvp = () => {
        return(
            <svg width="49" height="48" viewBox="0 0 49 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M41.933 28.4444H7.18683C6.91836 28.4444 6.68256 28.6227 6.60949 28.8811L3.0527 41.4556C2.69164 42.7321 3.65063 43.9999 4.97719 43.9999H43.6888C45.0154 43.9999 45.9744 42.7321 45.6133 41.4556L41.933 28.4444ZM41.933 28.4444V16.2222" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M6.7334 28.4444V6C6.7334 4.89543 7.62883 4 8.7334 4H24.3334" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M22.333 38L26.333 38" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M35.6465 9.65674L29.9896 15.3136" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M41.3033 9.65685C39.7412 11.219 37.2086 11.219 35.6465 9.65685C34.0844 8.09476 34.0844 5.5621 35.6465 4" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M29.9896 20.9706C31.5517 19.4085 31.5517 16.8759 29.9896 15.3138C28.4275 13.7517 25.8948 13.7517 24.3327 15.3138" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            
        )
    }
    const DevPhase = () => {
        return(
            <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 34L16.6667 34C15.5621 34 14.6667 33.1054 14.6667 32.0008C14.6667 30.2612 14.6667 27.781 14.6667 26.2222C14.6667 25.1111 12 24 12 24C12 24 14.6667 22.8889 14.6667 21.7778C14.6667 20.4199 14.6667 17.8175 14.6667 15.9985C14.6667 14.8939 15.5621 14 16.6667 14L20 14" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M28 34L31.3333 34C32.4379 34 33.3333 33.1054 33.3333 32.0008C33.3333 30.2612 33.3333 27.781 33.3333 26.2222C33.3333 25.1111 36 24 36 24C36 24 33.3333 22.8889 33.3333 21.7778C33.3333 20.4199 33.3333 17.8175 33.3333 15.9985C33.3333 14.8939 32.4379 14 31.3333 14L28 14" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M42 6.6V41.4C42 41.7314 41.7314 42 41.4 42H6.6C6.26863 42 6 41.7314 6 41.4V6.6C6 6.26863 6.26863 6 6.6 6H41.4C41.7314 6 42 6.26863 42 6.6Z" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        )
    }
    const ProjLaunch = () => {
        return(
            <svg width="49" height="48" viewBox="0 0 49 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.66602 40V8C4.66602 6.89543 5.56145 6 6.66602 6H42.666C43.7706 6 44.666 6.89543 44.666 8V40C44.666 41.1046 43.7706 42 42.666 42H6.66602C5.56145 42 4.66602 41.1046 4.66602 40Z" stroke="#333333" stroke-width="1.5"/>
            <path d="M4.66602 14L44.666 14" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M10.666 10.02L10.686 9.99778" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M16.666 10.02L16.686 9.99778" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M22.666 10.02L22.686 9.99778" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>

        )
    }

    const CustomSlider = ({ 
        value, 
        onChange, 
        min = 0, 
        max = 100, 
        step = 1,
        title,
        startLabel,
        endLabel,
        error,
        helperText,
        valueLabelDisplay = "auto"
    }) => {
        return (
            <Grid item xs={12} container justifyContent={"flex-start"} style={{marginTop: "20px"}}>
                {title && (
                    <Grid item style={{marginLeft: 10}}>
                        <CustomLabelXSmallRegular text={title}/>
                    </Grid>
                )}
                <Grid item container style={{
                    marginTop: 5, 
                    padding: "15px 20px",
                    backgroundColor: "white",
                    borderRadius: 20, 
                    border: "1px solid #DDDDDD"
                }}>
                    <Grid container alignItems="center" spacing={2}>
                        <Grid item xs>
                            <Grid container alignItems="center">
                                <Grid item>
                                    <CustomLabelXSmallRegular text={startLabel} color="#666666"/>
                                </Grid>
                                <Grid item xs sx={{ marginRight: 2, position: 'relative' }}>
                                    <Slider
                                        value={value}
                                        onChange={onChange}
                                        min={min}
                                        max={max}
                                        step={step}
                                        valueLabelDisplay={valueLabelDisplay}
                                        sx={{
                                            mx: 2,
                                            '& .MuiSlider-rail': {
                                                backgroundColor: '#F4F7FD',
                                                height: 8,
                                                opacity: 1,
                                            },
                                            '& .MuiSlider-track': {
                                                backgroundColor: '#2659DE',
                                                height: 10,
                                                border: 'none',
                                            },
                                            '& .MuiSlider-thumb': {
                                                width: 24,
                                                height: 24,
                                                backgroundColor: '#2659DE',
                                                '&:before': {
                                                    display: 'none',
                                                },
                                                '&:hover, &.Mui-active': {
                                                    boxShadow: '0 0 0 8px rgba(38, 89, 222, 0.16)',
                                                },
                                            },
                                            '& .MuiSlider-valueLabel': {
                                                backgroundColor: '#2659DE',
                                                borderRadius: '100px',
                                                padding: '4px 8px',
                                                fontSize: '14px',
                                                top: -6,
                                                '&:before': {
                                                    display: 'none',
                                                },
                                                '& *': {
                                                    background: 'transparent',
                                                    color: 'white',
                                                },
                                            },
                                        }}
                                    />
                                </Grid>
                                <Grid item style={{ minWidth: '40px' }}>
                                    <CustomLabelXSmallRegular text={endLabel} color="#666666"/>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                {error && (
                    <FormHelperText error>{helperText}</FormHelperText>
                )}
            </Grid>
        );
    };
    const Step3Form = ({ stage, data, onChange, onSubmit }) => {
        switch(stage) {
            case 'idea':
                return (
                    <Grid container>
                        <Grid item xs={12} container justifyContent={"flex-start"} style={{marginTop: "20px"}}>
                            <Grid item style={{marginLeft: 10}}>
                                <CustomLabelXSmallRegular text={"Describe your idea (500 max words)"}/>
                            </Grid>
                            <Grid item container style={{marginTop: 5}}>

                            <CustomTextMultipleField 
                                rows={15}
                                placeholder={"Tell us about your concept, the problem you're solving, and the target audience..."} 
                                value={step3.idea_description.value}
                                onChange={(e) => onChangeStep3(e, 'idea_description')}
                                error={step3.idea_description.showError}
                                helperText={step3.idea_description.showError ? step3.idea_description.error : ""}
                                otherInputProps={{
                                    sx: {
                                        '&.MuiOutlinedInput-root': {
                                            backgroundColor: "white",
                                        },
                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                        borderColor: '#5E17EB',
                                        borderWidth: '1px',
                                    },
                                    },
                                }}
                               
                                />
            
                            </Grid>
                        </Grid>
                        <Grid item xs={12} container justifyContent={"flex-start"} style={{marginTop: "20px"}}>
                            <Grid item style={{marginLeft: 10}}>
                                <CustomLabelXSmallRegular text={"What Industry Does This Idea Belong To?"}/>
                            </Grid>
                            <Grid item container style={{marginTop: 5}}>
                            <CustomDropdown
                              height={isMobile && "50px"}
                              container={IndustryistContainer}
                              value={[step3.industry.value]}
                              placeholder={"Select industry"}
                              onChange={(e) =>
                                onChangeStep3(e, "industry")
                              }
                              showError={step3.industry.showError}
                              error={
                                step3.industry.showError
                                  ? step3.industry.error
                                  : ""
                              }
                            //   startAdornment={
                            //     <InputAdornment position="start">
                            //       <img src={CLOCK_RIGHT} />
                            //     </InputAdornment>
                            //   }
                            />
                                {/* <CustomDropdown
                                    value={step3.industry.value}
                                    onChange={(e) => onChangeStep3(e, 'industry')}
                                    error={step3.industry.showError}
                                    helperText={step3.industry.showError ? step3.industry.error : ""}
                                    placeholder={"Select industry"}
                                    container={IndustryistContainer}
                                /> */}
                            </Grid>
                        </Grid>
                        <NavigationButtons onBack={() => setProgress(25)} onNext={onSubmit} />
                    </Grid>
                );

            case 'wireframes':
                return (
                    <Grid container>
                        <Grid item xs={12} container justifyContent={"flex-start"} style={{marginTop: "20px"}}>
                            <Grid item style={{marginLeft: 10}}>
                                <CustomLabelXSmallRegular text={"Upload Wireframes"}/>
                            </Grid>
                            <Grid item container style={{marginTop: 5}}>
                                <CustomFileUpload
                                    value={data.wireframes_file.value}
                                    onChange={(e) => onChange(e, 'wireframes_file')}
                                    error={data.wireframes_file.showError}
                                    helperText={data.wireframes_file.showError ? data.wireframes_file.error : ""}
                                    placeholder="PDF, PNG, Figma link, etc--"
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            backgroundColor: "white",
                                            borderRadius: "100px",
                                            '& fieldset': {
                                                borderColor: '#DDDDDD',
                                            },
                                            '&:hover fieldset': {
                                                borderColor: '#DDDDDD',
                                            },
                                            '&.Mui-focused fieldset': {
                                                borderColor: '#5E17EB',
                                            },
                                        },
                                        '& .MuiInputBase-input': {
                                            padding: "15px 20px",
                                            color: "#666666",
                                            fontSize: "14px",
                                            fontWeight: 400,
                                        },
                                    }}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M12 16L12 8" stroke="#666666" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                                    <path d="M9 11L12 8L15 11" stroke="#666666" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                                    <path d="M8 18H16" stroke="#666666" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                                </svg>
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid>
                        </Grid>
                        <Grid item xs={12} container justifyContent={"flex-start"} style={{marginTop: "20px"}}>
                            <Grid item style={{marginLeft: 10}}>
                                <CustomLabelXSmallRegular text={"Who created these wireframes?"}/>
                            </Grid>
                            <Grid item container style={{marginTop: 5}}>
                                <CustomDropdown
                                    value={[data.creator.value]}
                                    onChange={(e) => onChange(e, 'creator')}
                                    error={data.creator.showError}
                                    helperText={data.creator.showError ? data.creator.error : ""}
                                    placeholder={"Select creator"}
                                    container={WireframesCreatorList}
                                />
                            </Grid>
                        </Grid>
                        <Grid item xs={12} container justifyContent={"flex-start"} style={{marginTop: "20px"}}>
                            <Grid item style={{marginLeft: 10}}>
                                <CustomLabelXSmallRegular text={"Describe The functionality & Features"}/>
                            </Grid>
                            <Grid item container style={{marginTop: 5}}>
                                <CustomTextMultipleField
                                    value={data.features_description.value}
                                    onChange={(e) => onChange(e, 'features_description')}
                                    error={data.features_description.showError}
                                    helperText={data.features_description.showError ? data.features_description.error : ""}
                                    placeholder={"Describe your features..."} 
                                    rows={8}
                                    otherInputProps={{
                                        sx: {
                                            '&.MuiOutlinedInput-root': {
                                                backgroundColor: "white",
                                              },
                                          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                            borderColor: '#5E17EB',
                                            borderWidth: '1px',
                                          },
                                        },
                                      }}
                                />
                            </Grid>
                        </Grid>
                        <NavigationButtons onBack={() => setProgress(25)} onNext={onSubmit} />
                    </Grid>
                );

            case 'prototype':
                return (
                    <Grid container>
                        <Grid item xs={12} container justifyContent={"flex-start"} style={{marginTop: "20px"}}>
                            <Grid item style={{marginLeft: 10}}>
                                <CustomLabelXSmallRegular text={"Provide Access to Prototype"}/>
                            </Grid>
                            <Grid item container style={{marginTop: 5}}>
                                <CustomFileUpload
                                    value={data.prototype_access.value}
                                    onChange={(e) => onChange(e, 'prototype_access')}
                                    error={data.prototype_access.showError}
                                    helperText={data.prototype_access.showError ? data.prototype_access.error : ""}
                                />
                            </Grid>
                        </Grid>
                        <Grid item xs={12} container justifyContent={"flex-start"} style={{marginTop: "20px"}}>
                            <Grid item style={{marginLeft: 10}}>
                                <CustomLabelXSmallRegular text={"Who created this prototype design?"}/>
                            </Grid>
                            <Grid item container style={{marginTop: 5}}>
                                <CustomDropdown
                                    value={[data.prototype_creator.value]}
                                    onChange={(e) => onChange(e, 'prototype_creator')}
                                    error={data.prototype_creator.showError}
                                    helperText={data.prototype_creator.showError ? data.prototype_creator.error : ""}
                                    placeholder={"Select creator"}
                                    container={WireframesCreatorList}
                                />
                            </Grid>
                        </Grid>
                        <Grid item xs={12} container justifyContent={"flex-start"} style={{marginTop: "20px"}}>
                            <Grid item style={{marginLeft: 10}}>
                                <CustomLabelXSmallRegular text={"What Technologies were Used in the Prototype?"}/>
                            </Grid>
                            <Grid item container style={{marginTop: 5}}>
                                <CustomDropdown
                                    value={[data.tech_used_prototype.value]}
                                    onChange={(e) => onChange(e, 'tech_used_prototype')}
                                    error={data.tech_used_prototype.showError}
                                    helperText={data.tech_used_prototype.showError ? data.tech_used_prototype.error : ""}
                                    placeholder={"Select Technology Used"}
                                    container={PrototypeTechList}
                                />
                            </Grid>
                        </Grid>
                        <Grid item xs={12} container justifyContent={"flex-start"} style={{marginTop: "20px"}}>
                            <Grid item style={{marginLeft: 10}}>
                                <CustomLabelXSmallRegular text={"Describe The functionality & Features"}/>
                            </Grid>
                            <Grid item container style={{marginTop: 5}}>
                                <CustomTextMultipleField
                                    value={data.features_description.value}
                                    onChange={(e) => onChange(e, 'features_description')}
                                    error={data.features_description.showError}
                                    helperText={data.features_description.showError ? data.features_description.error : ""}
                                    placeholder={"Describe your features..."} 
                                    rows={8}
                                    otherInputProps={{
                                        sx: {
                                            '&.MuiOutlinedInput-root': {
                                                backgroundColor: "white",
                                              },
                                          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                            borderColor: '#5E17EB',
                                            borderWidth: '1px',
                                          },
                                        },
                                      }}
                                />
                            </Grid>
                        </Grid>
                        <NavigationButtons onBack={() => setProgress(25)} onNext={onSubmit} />
                    </Grid>
                );

            case 'mvp':
                return (
                    <Grid container>
                        <Grid item xs={12} container justifyContent={"flex-start"} style={{marginTop: "20px"}}>
                            <Grid item style={{marginLeft: 10}}>
                                <CustomLabelXSmallRegular text={"Provide MVP Access"}/>
                            </Grid>
                            <Grid item container style={{marginTop: 5}}>
                                <CustomFileUpload
                                    value={data.mvp_access.value}
                                    onChange={(e) => onChange(e, 'mvp_access')}
                                    error={data.mvp_access.showError}
                                    helperText={data.mvp_access.showError ? data.mvp_access.error : ""}
                                />
                            </Grid>
                        </Grid>

                        <CustomSlider
                            value={data.user_tested_mvp.value}
                            onChange={(e, value) => onChange({target: {value}}, 'user_tested_mvp')}
                            min={10}
                            max={500}
                            title="How many Users Have Tested the Prototype/MVP?"
                            startLabel="<10"
                            endLabel="500+"
                            error={data.user_tested_mvp.showError}
                            helperText={data.user_tested_mvp.showError ? data.user_tested_mvp.error : ""}
                        />

                        <Grid item xs={12} container justifyContent={"flex-start"} style={{marginTop: "20px"}}>
                            <Grid item style={{marginLeft: 10}}>
                                <CustomLabelXSmallRegular text={"What user Feedback Have You Received?"}/>
                            </Grid>
                            <Grid item container style={{marginTop: 5}}>
                                <CustomFileUpload
                                    value={data.user_feedback.value}
                                    onChange={(e) => onChange(e, 'user_feedback')}
                                    error={data.user_feedback.showError}
                                    helperText={data.user_feedback.showError ? data.user_feedback.error : ""}
                                />
                            </Grid>
                        </Grid>
                        <Grid item xs={12} container justifyContent={"flex-start"} style={{marginTop: "20px"}}>
                            <Grid item style={{marginLeft: 10}}>
                                <CustomLabelXSmallRegular text={"Describe The functionality & Features"}/>
                            </Grid>
                            <Grid item container style={{marginTop: 5}}>
                                <CustomTextMultipleField
                                    value={data.features_description.value}
                                    onChange={(e) => onChange(e, 'features_description')}
                                    error={data.features_description.showError}
                                    helperText={data.features_description.showError ? data.features_description.error : ""}
                                    placeholder={"Describe your features..."} 
                                    rows={8}
                                    otherInputProps={{
                                        sx: {
                                            '&.MuiOutlinedInput-root': {
                                                backgroundColor: "white",
                                              },
                                          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                            borderColor: '#5E17EB',
                                            borderWidth: '1px',
                                          },
                                        },
                                      }}
                                />
                            </Grid>
                        </Grid>
                        <NavigationButtons onBack={() => setProgress(25)} onNext={onSubmit} />
                    </Grid>
                );

            case 'development':
                return (
                    <Grid container>
                        <Grid item xs={12} container justifyContent={"flex-start"} style={{marginTop: "20px"}}>
                            <Grid item style={{marginLeft: 10}}>
                                <CustomLabelXSmallRegular text={"Provide Access to so far Development Project"}/>
                            </Grid>
                            <Grid item container style={{marginTop: 5}}>
                                <CustomFileUpload
                                    value={step3.development_project_access.value}
                                    onChange={(e) => onChange(e, 'development_project_access')}
                                    error={step3.development_project_access.showError}
                                    helperText={step3.development_project_access.showError ? step3.development_project_access.error : ""}
                                />
                            </Grid>
                        </Grid>
                        <Grid item xs={12} container justifyContent={"flex-start"} style={{marginTop: "20px"}}>
                            <Grid item style={{marginLeft: 10}}>
                                <CustomLabelXSmallRegular text={"Who is in your team?"}/>
                            </Grid>
                            <Grid item container style={{marginTop: 5}}>
                                <CustomTextMultipleField
                                    value={step3.team_description.value}
                                    onChange={(e) => onChange(e, 'team_description')}
                                    error={step3.team_description.showError}
                                    helperText={step3.team_description.showError ? step3.team_description.error : ""}
                                    placeholder={"Describe your team..."} 
                                    rows={5}
                                    otherInputProps={{
                                        sx: {
                                            '&.MuiOutlinedInput-root': {
                                                backgroundColor: "white",
                                              },
                                          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                            borderColor: '#5E17EB',
                                            borderWidth: '1px',
                                          },
                                        },
                                      }}
                                />
                            </Grid>
                        </Grid>
                        <Grid item xs={12} container justifyContent={"flex-start"} style={{marginTop: "20px"}}>
                            <Grid item style={{marginLeft: 10}}>
                                <CustomLabelXSmallRegular text={"Describe The functionality & Features"}/>
                            </Grid>
                            <Grid item container style={{marginTop: 5}}>
                                <CustomTextMultipleField
                                    value={data.features_description.value}
                                    onChange={(e) => onChange(e, 'features_description')}
                                    error={data.features_description.showError}
                                    helperText={data.features_description.showError ? data.features_description.error : ""}
                                    placeholder={"Describe your features..."} 
                                    rows={8}
                                    otherInputProps={{
                                        sx: {
                                            '&.MuiOutlinedInput-root': {
                                                backgroundColor: "white",
                                              },
                                          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                            borderColor: '#5E17EB',
                                            borderWidth: '1px',
                                          },
                                        },
                                      }}
                                />
                            </Grid>
                        </Grid>
                        <NavigationButtons onBack={() => setProgress(25)} onNext={onSubmit} />
                    </Grid>
                );

            case 'launched':
                return (
                    <Grid container>
                        <Grid item xs={12} container justifyContent={"flex-start"} style={{marginTop: "20px"}}>
                            <Grid item style={{marginLeft: 10}}>
                                <CustomLabelXSmallRegular text={"Link to Your Live Product"}/>
                            </Grid>
                            <Grid item container style={{marginTop: 5}}>
                                <CustomTextField
                                    value={data.live_product_link.value}
                                    onChange={(e) => onChange(e, 'live_product_link')}
                                    error={data.live_product_link.showError}
                                    helperText={data.live_product_link.showError ? data.live_product_link.error : ""}
                                    placeholder={"Enter your product URL"}
                                    otherInputProps={{
                                        sx: {
                                            '&.MuiOutlinedInput-root': {
                                                backgroundColor: "white",
                                              },
                                          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                            borderColor: '#5E17EB',
                                            borderWidth: '1px',
                                          },
                                        },
                                      }}
                                />
                            </Grid>
                        </Grid>

                        <CustomSlider
                            value={step3.active_users_percentage.value}
                            onChange={(e, value) => onChange({target: {value}}, 'active_users_percentage')}
                            min={100}
                            max={1000}
                            title="How Many Active Users Do You Have?"
                            startLabel="<100"
                            endLabel="10k+"
                            error={step3.active_users_percentage.showError}
                            helperText={step3.active_users_percentage.showError ? step3.active_users_percentage.error : ""}
                        />

                        <CustomSlider
                            value={step3.monthly_revenue_percentage.value}
                            onChange={(e, value) => onChange({target: {value}}, 'monthly_revenue_percentage')}
                            min={1000}
                            max={5000}
                            title="What is Your Current Monthly Revenue?"
                            startLabel="<1k"
                            endLabel="50k+"
                            error={step3.monthly_revenue_percentage.showError}
                            helperText={step3.monthly_revenue_percentage.showError ? step3.monthly_revenue_percentage.error : ""}
                        />

                        <Grid item xs={12} container justifyContent={"flex-start"} style={{marginTop: "20px"}}>
                            <Grid item style={{marginLeft: 10}}>
                                <CustomLabelXSmallRegular text={"Describe The functionality & Features"}/>
                            </Grid>
                            <Grid item container style={{marginTop: 5}}>
                                <CustomTextMultipleField
                                    value={data.features_description.value}
                                    onChange={(e) => onChange(e, 'features_description')}
                                    error={data.features_description.showError}
                                    helperText={data.features_description.showError ? data.features_description.error : ""}
                                    placeholder={"Describe your features..."} 
                                    rows={8}
                                    otherInputProps={{
                                        sx: {
                                            '&.MuiOutlinedInput-root': {
                                                backgroundColor: "white",
                                              },
                                          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                            borderColor: '#5E17EB',
                                            borderWidth: '1px',
                                          },
                                        },
                                      }}
                                />
                            </Grid>
                        </Grid>
                        <NavigationButtons onBack={() => setProgress(25)} onNext={onSubmit} />
                    </Grid>
                );

            default:
                return null;
        }
    }

    const getStep3Label = () => {
        switch(currentStage) {
            case 'idea':
                return 'Describe Your Idea';
            case 'wireframes':
                return 'Wireframes Info';
            case 'prototype':
                return 'Prototype Info';
            case 'mvp':
                return 'MVP Info';
            case 'development':
            case 'launched':
                return 'Project Info';
            default:
                return 'Describe Your Idea';
        }
    }
    const getStep4Label = () => {
        switch(currentStage) {
            case 'idea':
                return 'Research & Offer';
            case 'wireframes':
            case 'prototype':
            case 'mvp':
            case 'development':
            case 'launched':
                return 'Tech & Offer';
            default:
                return 'Tech & Offer';
        }
    }

    // Helper component for navigation buttons
    const NavigationButtons = ({ onBack, onNext }) => {
        return (
            <Grid item container justifyContent={"center"} sx={{paddingBottom: "40px", marginTop: "20px"}}>
                <div>
                    <Grid container alignItems={"center"} justifyContent={"center"}
                        sx={{
                            border: "1.5px solid #DDDDDD",
                            borderRadius: "20px",
                            padding: {xs: "8px 30px", md: "12px 80px"},
                            background: "white",
                            marginTop: "20px",
                            gap: "5px",
                            cursor: "pointer"
                        }}
                        onClick={onBack}
                    >
                        <Grid item style={{marginTop: "2px"}}>
                            <img src={ARROR_LEFT} alt={"ARROW LEFT"} />
                        </Grid>
                        <Grid item>
                            <CustomLabelSmallMedium text={"Back"} color={"black"}/>
                        </Grid>
                    </Grid>
                </div>

                <div style={{marginLeft: "20px"}}>
                    <Grid container alignItems={"center"} justifyContent={"center"}
                        sx={{
                            border: "1.5px solid #F5F5F5",
                            borderRadius: "20px",
                            padding: {xs: "12px 30px", md: "12px 80px"},
                            background: "#5E17EB",
                            marginTop: "20px",
                            gap: "10px",
                            cursor:"pointer"
                        }}
                        onClick={onNext}
                    >
                        <Grid item>
                            <CustomLabelSmallMedium text={"Next"} color={"white"}/>
                        </Grid>
                        <Grid item>
                            <img src={ARROW_RIGHT_WITHOUT_BORDER} alt={"ARROW RIGHT WITHOUT BORDER"} />
                        </Grid>
                    </Grid>
                </div>
            </Grid>
        );
    }

    const Step4Form = ({ stage, data, onChange }) => {
        // const techStackOptions = [
        //     "React",
        //     "Laravel",
        //     "Angular",
        //     "Vue.js",
        //     "Node.js",
        //     "Django",
        //     "Flask",
        //     "Ruby on Rails"
        // ];

        // const technicalChallenges = [
        //     "Bugs",
        //     "Scalability",
        //     "Performance",
        //     "Security",
        //     "Integration Issues",
        //     "Technical Debt"
        // ];

        // const roadmapOptions = [
        //     "Build MVP",
        //     "Secure Funding",
        //     "Scale Users",
        //     "Monetization",
        //     "Market Expansion"
        // ];

        const renderYesNoButtons = (field, title) => (
            <Grid item xs={12} container justifyContent={"flex-start"} style={{marginTop: "20px"}}>
                <Grid item style={{marginLeft: 10}}>
                    <CustomLabelXSmallRegular text={title}/>
                </Grid>
                <Grid item container style={{marginTop: 5}}>
                    <Grid container justifyContent={"space-between"}>
                        <Grid item xs={5.5}>
                            <Paper
                                onClick={() => onChange({target: {value: "yes"}}, field)}
                                sx={{
                                    width: "100%",
                                    background: "white",
                                    padding: "15px 0px",
                                    borderRadius: "25px",
                                    cursor: "pointer",
                                    border: data[field].value === "yes" ? "1px solid #5E17EB" : "1px solid #DDDDDD"
                                }}>
                                <Grid container alignItems={"center"} direction={"column"}>
                                    <CustomLabelXSmallBold
                                        color={data[field].value === "yes" ? "#5E17EB" : "black"}
                                        text={"Yes"}/>
                                </Grid>
                            </Paper>
                        </Grid>
                        <Grid item xs={5.5}>
                            <Paper
                                onClick={() => onChange({target: {value: "no"}}, field)}
                                sx={{
                                    width: "100%",
                                    background: "white",
                                    padding: "15px 0px",
                                    borderRadius: "25px",
                                    cursor: "pointer",
                                    border: data[field].value === "no" ? "1px solid #5E17EB" : "1px solid #DDDDDD"
                                }}>
                                <Grid container alignItems={"center"} direction={"column"}>
                                    <CustomLabelXSmallBold
                                        color={data[field].value === "no" ? "#5E17EB" : "black"}
                                        text={"No"}/>
                                </Grid>
                            </Paper>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        );

        switch(stage) {
            case 'idea':
                return (
                    <Grid container>
                        {renderYesNoButtons('market_research', 'Have You Conducted Market Research?')}
                        {renderYesNoButtons('competitor_analysis', 'Do You Have Competitor Analysis?')}
                        {renderYesNoButtons('willing_equity', 'Are you Willing to Give Equity in Exchange for Development?')}
                        <CustomSlider
                            value={step4.equity_willing_for_perc.value}
                            onChange={(e, value) => onChange({target: {value}}, 'equity_willing_for_perc')}
                            min={1}
                            max={50}
                            title="How much Equity Are You Willing For?"
                            startLabel="1%"
                            endLabel="50%"
                            error={step4.equity_willing_for_perc.showError}
                            helperText={step4.equity_willing_for_perc.showError ? step4.equity_willing_for_perc.error : ""}
                        />
                    </Grid>
                );

            case 'wireframes':
                return (
                    <Grid container>
                        {renderYesNoButtons('technical_cofounder', 'Do You Have a Technical Co-founder?')}
                        <Grid item xs={12} container justifyContent={"flex-start"} style={{marginTop: "20px"}}>
                            <Grid item style={{marginLeft: 10}}>
                                <CustomLabelXSmallRegular
                                    text={"Which tech stack or framework do you prefer?"}/>
                            </Grid>
                            <Grid item container style={{marginTop: 5}}>
                                <CustomDropdown
                                    value={[step4.tech_stack.value]}
                                    onChange={(e) => onChangeStep4(e, 'tech_stack')}
                                    error={step4.tech_stack.showError}
                                    helperText={step4.tech_stack.showError ? step4.tech_stack.error : ""}
                                    placeholder={"Select tech stack"}
                                    container={TechStackList}
                                />
                            </Grid>
                        </Grid>
                        {renderYesNoButtons('user_testing', 'Have you conducted User Testing on the Wireframes?')}
                        <CustomSlider
                            value={step4.equity_willing_for_perc.value}
                            onChange={(e, value) => onChange({target: {value}}, 'equity_willing_for_perc')}
                            min={1}
                            max={50}
                            title="How much Equity Are You Willing For?"
                            startLabel="1%"
                            endLabel="50%"
                            error={step4.equity_willing_for_perc.showError}
                            helperText={step4.equity_willing_for_perc.showError ? step4.equity_willing_for_perc.error : ""}
                        />
                    </Grid>
                );

            case 'prototype':
                return (
                    <Grid container>
                        {renderYesNoButtons('user_feedback', 'Do You Have Feedback from users?')}
                        <Grid item xs={12} container justifyContent={"flex-start"} style={{marginTop: "10px"}}>
                            <Grid item style={{marginLeft: 10}}>
                                <CustomLabelXSmallRegular
                                    text={"What is Your Roadmap After the prototype?"}/>
                            </Grid>
                            <Grid item container style={{marginTop: "5px"}}>
                                <CustomDropdown
                                    value={[step4.road_map_after_prototype.value]}
                                    onChange={(e) => onChangeStep4(e, 'road_map_after_prototype')}
                                    error={step4.road_map_after_prototype.showError}
                                    helperText={step4.road_map_after_prototype.showError ? step4.road_map_after_prototype.error : ""}
                                    placeholder={"Build MVP, Secure Funding, etc --"}
                                    container={RoadmapList}
                                />
                            </Grid>
                        </Grid>
                        {renderYesNoButtons('technical_cofounder', 'Do You Have a Technical Co-founder?')}
                        <Grid item xs={12} container justifyContent={"flex-start"} style={{marginTop: "10px"}}>
                            <Grid item style={{marginLeft: 10}}>
                                <CustomLabelXSmallRegular
                                    text={"Which tech stack or framework do you prefer?"}/>
                            </Grid>
                            <Grid item container style={{marginTop: 5}}>
                                <CustomDropdown
                                    value={[step4.tech_stack.value]}
                                    onChange={(e) => onChangeStep4(e, 'tech_stack')}
                                    error={step4.tech_stack.showError}
                                    helperText={step4.tech_stack.showError ? step4.tech_stack.error : ""}
                                    placeholder={"Select tech stack"}
                                    container={TechStackList}
                                />
                            </Grid>
                        </Grid>
                        {renderYesNoButtons('pitched_investors', 'Have you Pitched this Prototype to Investors?')}
                        <CustomSlider
                            value={step4.equity_willing_for_perc.value}
                            onChange={(e, value) => onChange({target: {value}}, 'equity_willing_for_perc')}
                            min={1}
                            max={50}
                            title="How much Equity Are You Willing For?"
                            startLabel="1%"
                            endLabel="50%"
                            error={step4.equity_willing_for_perc.showError}
                            helperText={step4.equity_willing_for_perc.showError ? step4.equity_willing_for_perc.error : ""}
                        />
                    </Grid>
                );

            case 'mvp':
                return (
                    <Grid container>
                        <Grid item xs={12} container justifyContent={"flex-start"} style={{marginTop: "10px"}}>
                            <Grid item style={{marginLeft: 10}}>
                                <CustomLabelXSmallRegular
                                    text={"What are Your Biggest Technical Challenges Right Now?"}/>
                            </Grid>
                            <Grid item container style={{marginTop: 5}}>
                                <CustomDropdown
                                    value={[step4.technical_challenges.value]}
                                    onChange={(e) => onChangeStep4(e, 'technical_challenges')}
                                    error={step4.technical_challenges.showError}
                                    helperText={step4.technical_challenges.showError ? step4.technical_challenges.error : ""}
                                    placeholder={"Select challenges"}
                                    container={TechChallengeList}
                                />
                            </Grid>
                        </Grid>
                        <Grid item xs={12} container justifyContent={"flex-start"} style={{marginTop: "10px"}}>
                            <Grid item style={{marginLeft: 10}}>
                                <CustomLabelXSmallRegular
                                    text={"Which tech stack or framework do you prefer?"}/>
                            </Grid>
                            <Grid item container style={{marginTop: 5}}>
                                <CustomDropdown
                                    value={[step4.tech_stack.value]}
                                    onChange={(e) => onChangeStep4(e, 'tech_stack')}
                                    error={step4.tech_stack.showError}
                                    helperText={step4.tech_stack.showError ? step4.tech_stack.error : ""}
                                    placeholder={"Select tech stack"}
                                    container={TechStackList}
                                />
                            </Grid>
                        </Grid>
                        {renderYesNoButtons('technical_cofounder', 'Do You Have a Technical Co-founder?')}
                        {renderYesNoButtons('pitched_prototype_to_investors', 'Have you Pitched this Prototype to Investors?')}
                        <CustomSlider
                            value={data.equity_willing_for_perc.value}
                            onChange={(e, value) => onChange({target: {value}}, 'equity_willing_for_perc')}
                            min={1}
                            max={50}
                            title="How much Equity Are You Willing For?"
                            startLabel="1%"
                            endLabel="50%"
                            error={data.equity_willing_for_perc.showError}
                            helperText={data.equity_willing_for_perc.showError ? data.equity_willing_for_perc.error : ""}
                        />
                    </Grid>
                );

            case 'development':
                return (
                    <Grid container>
                        <Grid item xs={12} container justifyContent={"flex-start"} style={{marginTop: "10px"}}>
                            <Grid item style={{marginLeft: 10}}>
                                <CustomLabelXSmallRegular
                                    text={"What are Your Biggest Technical Challenges Right Now?"}/>
                            </Grid>
                            <Grid item container style={{marginTop: 5}}>
                                <CustomDropdown
                                    value={[step4.technical_challenges.value]}
                                    onChange={(e) => onChangeStep4(e, 'technical_challenges')}
                                    error={step4.technical_challenges.showError}
                                    helperText={step4.technical_challenges.showError ? step4.technical_challenges.error : ""}
                                    placeholder={"Select challenges"}
                                    container={TechChallengeList}
                                />
                            </Grid>
                        </Grid>
                        <Grid item xs={12} container justifyContent={"flex-start"} style={{marginTop: "10px"}}>
                            <Grid item style={{marginLeft: 10}}>
                                <CustomLabelXSmallRegular
                                    text={"Which tech stack or framework do you prefer?"}/>
                            </Grid>
                            <Grid item container style={{marginTop: 5}}>
                                <CustomDropdown
                                    value={[step4.tech_stack.value]}
                                    onChange={(e) => onChangeStep4(e, 'tech_stack')}
                                    error={step4.tech_stack.showError}
                                    helperText={step4.tech_stack.showError ? step4.tech_stack.error : ""}
                                    placeholder={"Select tech stack"}
                                    container={TechStackList}
                                />
                            </Grid>
                        </Grid>
                        {renderYesNoButtons('technical_cofounder', 'Do You Have a Technical Co-founder?')}
                        {renderYesNoButtons('generating_revenue', 'Are You Generating Revenue?')}
                        {renderYesNoButtons('pitched_prototype_to_investors', 'Have you Pitched this Prototype to Investors?')}
                        <CustomSlider
                            value={data.equity_willing_for_perc.value}
                            onChange={(e, value) => onChange({target: {value}}, 'equity_willing_for_perc')}
                            min={1}
                            max={50}
                            title="How much Equity Are You Willing For?"
                            startLabel="1%"
                            endLabel="50%"
                            error={data.equity_willing_for_perc.showError}
                            helperText={data.equity_willing_for_perc.showError ? data.equity_willing_for_perc.error : ""}
                        />
                    </Grid>
                );

            case 'launched':
                return (
                    <Grid container>
                         <Grid item xs={12} container justifyContent={"flex-start"} style={{marginTop: "10px"}}>
                            <Grid item style={{marginLeft: 10}}>
                                <CustomLabelXSmallRegular
                                    text={"What are Your Biggest Technical Challenges Right Now?"}/>
                            </Grid>
                            <Grid item container style={{marginTop: 5}}>
                                <CustomDropdown
                                    value={[step4.technical_challenges.value]}
                                    onChange={(e) => onChangeStep4(e, 'technical_challenges')}
                                    error={step4.technical_challenges.showError}
                                    helperText={step4.technical_challenges.showError ? step4.technical_challenges.error : ""}
                                    placeholder={"Select challenges"}
                                    container={TechChallengeList}
                                />
                            </Grid>
                        </Grid>
                        {renderYesNoButtons('need_support', 'Do You Need ongoing Development Support?')}
                        <Grid item xs={12} container justifyContent={"flex-start"} style={{marginTop: "10px"}}>
                            <Grid item style={{marginLeft: 10}}>
                                <CustomLabelXSmallRegular
                                    text={"Which tech stack or framework do you prefer?"}/>
                            </Grid>
                            <Grid item container style={{marginTop: 5}}>
                                <CustomDropdown
                                    value={[step4.tech_stack.value]}
                                    onChange={(e) => onChangeStep4(e, 'tech_stack')}
                                    error={step4.tech_stack.showError}
                                    helperText={step4.tech_stack.showError ? step4.tech_stack.error : ""}
                                    placeholder={"Select tech stack"}
                                    container={TechStackList}
                                />
                            </Grid>
                        </Grid>
                        {renderYesNoButtons('has_investors', 'Do You Have Investors already?')}
                        <CustomSlider
                            value={data.equity_willing_for_perc.value}
                            onChange={(e, value) => onChange({target: {value}}, 'equity_willing_for_perc')}
                            min={1}
                            max={50}
                            title="How much Equity Are You Willing For?"
                            startLabel="1%"
                            endLabel="50%"
                            error={data.equity_willing_for_perc.showError}
                            helperText={data.equity_willing_for_perc.showError ? data.equity_willing_for_perc.error : ""}
                        />
                    </Grid>
                );

            default:
                return null;
        }
    };

    return (
        <>
            <Grid 
                container 
                className="modal-overlay"
                onClick={handleClickOutside}
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.1)',
                    zIndex: 1000,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}
            >
                <Grid item onClick={e => e.stopPropagation()}>
                    {isLoading && <Loader/>}
                    <Grid 
                        direction={"row"} 
                        container 
                        item 
                        xs={12} 
                        sm={10} 
                        md={9} 
                        lg={6} 
                        xls={5.5} 
                        justifyContent={"center"}
                        sx={{
                            position: "fixed",
                            top: 0,
                            right: 0,
                            zIndex: 11,
                            padding: {xs: "20px 10px", sm: "40px", md: "40px"},
                            background: "#FAF7FF",
                            borderRadius: "25px 0px 0px 25px",
                            overflowY: "scroll",
                            height: "100%"
                        }}
                    >
                            <Grid container>
                                {/* Header */}
                                <Grid item container justifyContent={"space-between"} alignItems={"center"}>
                                    <Grid item xs={9}>
                                        <CustomLabelMediumSmallBold text={"Project by Equity"} color={"#5E17EB"}/>
                                    </Grid>
                                    <Grid item>
                                        <Grid item container justifyContent={"center"}>
                                            <Grid item container
                                                  style={{
                                                      border: "1.5px solid #DDDDDD",
                                                      background: "white",
                                                      borderRadius: "20px",
                                                      width: "56px",
                                                      height: "56px",
                                                      cursor: "pointer"
                                                  }}
                                                  alignItems={"center"}
                                                  justifyContent={"center"}
                                                  onClick={(e) => setShowProjectByEquity(false)}
                                            >
                                                <Grid item>
                                                    <img src={XMARK} alt={"XMARK"} />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {/* Progress section */}
                                <Grid item container xs={12} sx={{marginTop: {xs: "20px", md: "40px"}}}>
                                    <Stack spacing={2} sx={{flex: 1, position: "relative"}}>
                                        <LinearProgress variant="determinate" value={progress}
                                                        sx={{
                                                            height: 10,
                                                            borderRadius: 5,
                                                            border: "1px solid #DDDDDD",
                                                            backgroundColor: 'white', // Background color
                                                            '& .MuiLinearProgress-bar': {
                                                                backgroundColor: '#5E17EB', // Progress bar color
                                                            },
                                                        }}
                                        />
                                        <Box
                                            sx={{
                                                position: 'absolute',
                                                top: -10,
                                                left: `calc(${progress}% - 10px)`,
                                                transform: 'translateY(-50%)',
                                                width: 15,
                                                height: 15,
                                                borderRadius: '50%',
                                                backgroundColor: '#5E17EB',
                                                border: '1px solid white',
                                                boxShadow: '0 0 5px rgba(0,0,0,0.5)',
                                                transition: 'left 0.5s ease',
                                            }}
                                        />
                                    </Stack>
                                    <Grid container justifyContent={"space-between"} style={{marginTop: "5px"}}>
                                        <Grid item>
                                            <CustomLabelSmallMedium text={"Basic Info"} color={"#5E17EB"}/>
                                        </Grid>
                                        <Grid item>
                                            <CustomLabelSmallMedium text={"Project Standing"} color={"#5E17EB"}/>
                                        </Grid>
                                        <Grid item>
                                            <CustomLabelSmallMedium text={getStep3Label()} color={"#5E17EB"}/>
                                        </Grid>
                                        <Grid item>
                                            <CustomLabelSmallMedium text={getStep4Label()} color={"#5E17EB"}/>
                                        </Grid>
                                        <Grid item>
                                            <CustomLabelSmallMedium text={"Other Info"} color={"#5E17EB"}/>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {/* Form Steps */}
                                <Grid item container xs={12}>
                                    {progress === 5 && (
                                        <Grid container sx={{marginTop: {xs: "30px", md: "40px"}, marginBottom : {xs: 10 , md : 20}}}>
                                            <Grid item xs={12} container justifyContent={"flex-start"}>
                                                <Grid item style={{marginLeft: 10}}>
                                                    <CustomLabelXSmallRegular text={"Full Name"}/>
                                                </Grid>
                                                <Grid item container style={{marginTop: 5}}>
                                                    <CustomTextField placeholder={"Type your full name here..."}
                                                                     height={isMobile && "50px"}
                                                                     value={step1.full_name.value}
                                                                     onChange={(e) => onChangeStep1(e, 'full_name')}
                                                                     error={step1.full_name.showError}
                                                                     helperText={step1.full_name.showError ? step1.full_name.error : ""}
                                                                     startAdornment={
                                                                         <InputAdornment position="start">
                                                                             <img src={USER} alt={"USER"} />
                                                                         </InputAdornment>

                                                                     }
                                                                     otherInputProps={{
                                                                        sx: {
                                                                            '&.MuiOutlinedInput-root': {
                                                                                backgroundColor: "white",
                                                                              },
                                                                          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                                            borderColor: '#5E17EB',
                                                                            borderWidth: '1px',
                                                                          },
                                                                        },
                                                                      }}/>
                                                </Grid>
                                            </Grid>


                                            <Grid item xs={12} container justifyContent={"flex-start"} style={{marginTop: "20px"}}>
                                                <Grid item style={{marginLeft: 10}}>
                                                    <CustomLabelXSmallRegular text={"Email Address"}/>
                                                </Grid>
                                                <Grid item container style={{marginTop: 5}}>
                                                    <CustomTextField placeholder={"example@email.com"}
                                                                     height={isMobile && "50px"}
                                                                     value={step1.email.value}
                                                                     onChange={(e) => onChangeStep1(e, 'email')}
                                                                     error={step1.email.showError}
                                                                     helperText={step1.email.showError ? step1.email.error : ""}
                                                                     startAdornment={
                                                                         <InputAdornment position="start">
                                                                             <img src={MAIL_BLACK} alt={"MAIL BLACK"} />
                                                                         </InputAdornment>

                                                                     }
                                                                     otherInputProps={{
                                                                        sx: {
                                                                            '&.MuiOutlinedInput-root': {
                                                                                backgroundColor: "white",
                                                                              },
                                                                          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                                            borderColor: '#5E17EB',
                                                                            borderWidth: '1px',
                                                                          },
                                                                        },
                                                                      }}/>
                                                </Grid>
                                            </Grid>


                                            <Grid item xs={12} container justifyContent={"flex-start"} style={{marginTop: "20px"}}>
                                                <Grid item style={{marginLeft: 10}}>
                                                    <CustomLabelXSmallRegular text={"Project Title"}/>
                                                </Grid>
                                                <Grid item container style={{marginTop: 5}}>
                                                    <CustomTextField placeholder={"Type here..."}
                                                                     height={isMobile && "50px"}
                                                                     value={step1.project_title.value}
                                                                     onChange={(e) => onChangeStep1(e, 'project_title')}
                                                                     error={step1.project_title.showError}
                                                                     helperText={step1.project_title.showError ? step1.project_title.error : ""}
                                                                     otherInputProps={{
                                                                        sx: {
                                                                            '&.MuiOutlinedInput-root': {
                                                                                backgroundColor: "white",
                                                                              },
                                                                          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                                            borderColor: '#5E17EB',
                                                                            borderWidth: '1px',
                                                                          },
                                                                        },
                                                                      }}
                                                    />
                                                </Grid>
                                            </Grid>

                                                    <Grid container style={{marginTop: "20px"}}>
                                                        <Grid item style={{marginLeft: 10}}>
                                                            <CustomLabelXSmallRegular text={"Project Description"}/>
                                                        </Grid>
                                                        <Grid item container style={{marginTop: 5}}>
                                                            <CustomTextMultipleField placeholder={"What's on your mind?"} rows={5}
                                                                                     value={step1.project_description.value}
                                                                                     onChange={(e) => onChangeStep1(e, 'project_description')}
                                                                                     error={step1.project_description.showError}
                                                                                     helperText={step1.project_description.showError ? step1.project_description.error : ""}
                                                                                     otherInputProps={{
                                                                                        sx: {
                                                                                            '&.MuiOutlinedInput-root': {
                                                                                                backgroundColor: "white",
                                                                                              },
                                                                                          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                                                            borderColor: '#5E17EB',
                                                                                            borderWidth: '1px',
                                                                                          },
                                                                                        },
                                                                                      }}

                                                    />
                                                </Grid>
                                            </Grid>


                                            <Grid item container justifyContent={"center"} style={{marginTop: "10px"}}>
                                                <div>
                                                    <Grid container alignItems={"center"} justifyContent={"center"}
                                                          sx={{
                                                              border: "1.5px solid #F5F5F5",
                                                              borderRadius: "20px",
                                                              padding: {xs: "10px 40px", md: "8px 60px"},
                                                              background: "#5E17EB", marginTop: "20px",
                                                              cursor: "pointer"

                                                          }}
                                                          onClick={onSubmitStep1}
                                                    >
                                                        <Grid item>
                                                            <CustomLabelSmallMedium text={"Next"} color={"white"}/>
                                                        </Grid>


                                                        <Grid item style={{marginLeft: "5px", marginTop: "4px"}}>
                                                            <img src={ARROW_RIGHT_WITHOUT_BORDER} alt={"ARROW RIGHT WITHOUT BORDER"} />
                                                        </Grid>
                                                    </Grid>
                                                </div>
                                            </Grid>


                                        </Grid>
                                    )}

                                    {progress === 25 && (
                                        <Grid container>
                                            <Grid container sx={{marginTop: {xs: "30px", md: "40px"}}}>
                                                <Grid item xs={12} container justifyContent={"flex-start"} style={{marginTop: "20px"}}>
                                                    <Grid item style={{marginLeft: 10}}>
                                                        <CustomLabelXSmallRegular
                                                            text={"Do you have any initial investment or funding?"}/>
                                                    </Grid>
                                                    <Grid item container style={{marginTop: 5}}>
                                                        <Grid container direction="column">
                                                            <Grid container justifyContent={"space-between"}>
                                                                {/* Existing Yes/No buttons */}
                                                                <Grid item xs={5.5}>
                                                                    <Paper
                                                                        onClick={(e) => onChangeStep2({target: {value: "yes"}}, 'initial_fund')}
                                                                        sx={{
                                                                            width: "100%",
                                                                            background: "white",
                                                                            padding: {xs: "15px 0px", md: "15px 10px"},
                                                                            borderRadius: "25px",
                                                                            cursor: "pointer",
                                                                            border: step2.initial_fund.value === "yes" ? "1px solid #5E17EB" : "1px solid #DDDDDD"
                                                                        }}>
                                                                        <Grid container alignItems={"center"} direction={"column"}>
                                                                            <Grid item>
                                                                                <CustomLabelXSmallBold
                                                                                    color={step2.initial_fund.value === "yes" ? "#5E17EB" : "black"}
                                                                                    text={"Yes"}/>
                                                                            </Grid>
                                                                        </Grid>
                                                                    </Paper>
                                                                </Grid>
                                                                <Grid item xs={5.5}>
                                                                    <Paper
                                                                        onClick={(e) => onChangeStep2({target: {value: "no"}}, 'initial_fund')}
                                                                        sx={{
                                                                            width: "100%",
                                                                            background: "white",
                                                                            padding: {xs: "15px 0px", md: "15px 10px"},
                                                                            borderRadius: "25px",
                                                                            cursor: "pointer",
                                                                            border: step2.initial_fund.value === "no" ? "1px solid #5E17EB" : "1px solid #DDDDDD"
                                                                        }}>
                                                                        <Grid container alignItems={"center"} direction={"column"}>
                                                                            <Grid item>
                                                                                <CustomLabelXSmallBold
                                                                                    color={step2.initial_fund.value === "no" ? "#5E17EB" : "black"}
                                                                                    text={"No"}/>
                                                                            </Grid>
                                                                        </Grid>
                                                                    </Paper>
                                                                </Grid>
                                                            </Grid>
                                                            {step2.initial_fund.showError && (
                                                                <FormHelperText error sx={{marginLeft: '10px', marginTop: '5px'}}>
                                                                    {step2.initial_fund.error}
                                                                </FormHelperText>
                                                            )}
                                                        </Grid>
                                                    </Grid>
                                                </Grid>

                                                <Grid item xs={12} container justifyContent={"flex-start"} style={{marginTop: "20px"}}>
                                                    <Grid item style={{marginLeft: 10}}>
                                                        <CustomLabelXSmallRegular
                                                            textAlign={"left"}
                                                            text={"Are you open to partial equity or a hybrid investment model?"}/>
                                                    </Grid>
                                                    <Grid item container style={{marginTop: 5}}>
                                                        <Grid container direction="column">
                                                            <Grid container justifyContent={"space-between"}>
                                                                {/* Existing Yes/No/Not Sure buttons */}
                                                                <Grid item xs={3.8}>
                                                                    <Paper
                                                                        onClick={(e) => onChangeStep2({target: {value: "yes"}}, 'investment_model')}
                                                                        sx={{
                                                                            width: "100%",
                                                                            background: "white",
                                                                            padding: {xs: "15px 0px", md: "15px 0px"},
                                                                            borderRadius: "25px",
                                                                            cursor: "pointer",
                                                                            border: step2.investment_model.value === "yes" ? "1px solid #5E17EB" : "1px solid #DDDDDD"
                                                                        }}>
                                                                        <Grid container alignItems={"center"} direction={"column"}>
                                                                            <Grid item>
                                                                                <CustomLabelXSmallBold
                                                                                    color={step2.investment_model.value === "yes" ? "#5E17EB" : "black"}
                                                                                    text={"Yes"}/>
                                                                            </Grid>
                                                                        </Grid>
                                                                    </Paper>
                                                                </Grid>
                                                                <Grid item xs={3.8}>
                                                                    <Paper
                                                                        onClick={(e) => onChangeStep2({target: {value: "no"}}, 'investment_model')}
                                                                        sx={{
                                                                            width: "100%",
                                                                            background: "white",
                                                                            padding: {xs: "15px 0px", md: "15px 0px"},
                                                                            borderRadius: "25px",
                                                                            cursor: "pointer",
                                                                            border: step2.investment_model.value === "no" ? "1px solid #5E17EB" : "1px solid #DDDDDD"
                                                                        }}>
                                                                        <Grid container alignItems={"center"} direction={"column"}>
                                                                            <Grid item>
                                                                                <CustomLabelXSmallBold
                                                                                    color={step2.investment_model.value === "no" ? "#5E17EB" : "black"}
                                                                                    text={"No"}/>
                                                                            </Grid>
                                                                        </Grid>
                                                                    </Paper>
                                                                </Grid>
                                                                <Grid item xs={3.8}>
                                                                    <Paper
                                                                        onClick={(e) => onChangeStep2({target: {value: "not_sure"}}, 'investment_model')}
                                                                        sx={{
                                                                            width: "100%",
                                                                            background: "white",
                                                                            padding: {xs: "15px 0px", md: "15px 0px"},
                                                                            borderRadius: "25px",
                                                                            cursor: "pointer",
                                                                            border: step2.investment_model.value === "not_sure" ? "1px solid #5E17EB" : "1px solid #DDDDDD"
                                                                        }}>
                                                                        <Grid container alignItems={"center"} direction={"column"}>
                                                                            <Grid item>
                                                                                <CustomLabelXSmallBold text={"Not Sure"}
                                                                                                       color={step2.investment_model.value === "not_sure" ? "#5E17EB" : "black"}
                                                                            />
                                                                            </Grid>
                                                                        </Grid>
                                                                    </Paper>
                                                                </Grid>
                                                            </Grid>
                                                            {step2.investment_model.showError && (
                                                                <FormHelperText error sx={{marginLeft: '10px', marginTop: '5px'}}>
                                                                    {step2.investment_model.error}
                                                                </FormHelperText>
                                                            )}
                                                        </Grid>
                                                    </Grid>
                                                </Grid>

                                                <Grid item style={{marginLeft: 10, marginTop: 10}}>
                                                    <CustomLabelXSmallRegular text={"What stage is your project currently in?"}/>
                                                </Grid>
                                                <Grid item container style={{marginTop: 5}}>
                                                    <Grid container direction="column">
                                                        <Grid container justifyContent={"space-between"}>
                                                            {/* Existing project stage buttons */}
                                                            <Grid item xs={5.5} md={3.5}>
                                                                <Paper
                                                                    onClick={(e) => onChangeStep2({target: {value: "idea"}}, 'project_standing')}
                                                                    sx={{
                                                                        width: "100%",
                                                                        background: "white",
                                                                        padding: {xs: "20px 0px", md: "20px 10px"},
                                                                        borderRadius: "25px",
                                                                        cursor: "pointer",
                                                                        border: step2.project_standing.value === "idea" && "1px solid #5E17EB"
                                                                    }}>
                                                                    <Grid container alignItems={"center"} direction={"column"}>
                                                                        <Grid item>
                                                                            <img src={LIGHT_BULB} alt={"LIGHT BULB"} />
                                                                        </Grid>
                                                                        <Grid item style={{marginTop: "5px"}}>
                                                                            <CustomLabelXSmallBold
                                                                                color={step2.project_standing.value === "idea" ? "#5E17EB" : "#A3A3A3"}
                                                                                text={"I Want to Pitch an Idea"}/>
                                                                        </Grid>
                                                                        <Grid>

                                                                        </Grid>
                                                                    </Grid>
                                                                </Paper>
                                                            </Grid>
                                                            <Grid item xs={5.5} md={3.5}>
                                                                <Paper
                                                                    onClick={(e) => onChangeStep2({target: {value: "wireframes"}}, 'project_standing')}
                                                                    sx={{
                                                                        width: "100%",
                                                                        background: "white",
                                                                        padding: {xs: "20px 0px", md: "20px 10px"},
                                                                        borderRadius: "25px",
                                                                        cursor: "pointer",
                                                                        border: step2.project_standing.value === "wireframes" && "1px solid #5E17EB"
                                                                    }}>
                                                                    <Grid container alignItems={"center"} direction={"column"}>
                                                                        <Box item>
                                                                            <Wireframe/>
                                                                        </Box>
                                                                        <Grid item style={{marginTop: "5px"}}>
                                                                            <CustomLabelXSmallBold
                                                                                color={step2.project_standing.value === "wireframes" ? "#5E17EB" : "#A3A3A3"}
                                                                                text={"I have Wirefrmaes"}/>
                                                                        </Grid>
                                                                        <Grid>

                                                                        </Grid>
                                                                    </Grid>
                                                                </Paper>
                                                            </Grid>
                                                            <Grid item xs={5.5} md={3.5}>
                                                                <Paper
                                                                    onClick={(e) => onChangeStep2({target: {value: "prototype"}}, 'project_standing')}
                                                                    sx={{
                                                                        width: "100%",
                                                                        background: "white",
                                                                        padding: {xs: "20px 0px", md: "20px 10px"},
                                                                        borderRadius: "25px",
                                                                        cursor: "pointer",
                                                                        border: step2.project_standing.value === "prototype" && "1px solid #5E17EB"
                                                                    }}>
                                                                    <Grid container alignItems={"center"} direction={"column"}>
                                                                        <Grid item>
                                                                            <img src={DESIGN_NIB} alt={"DESIGN NIB"} />
                                                                        </Grid>
                                                                        <Grid item style={{marginTop: "5px"}}>
                                                                            <CustomLabelXSmallBold
                                                                                color={step2.project_standing.value === "prototype" ? "#5E17EB" : "#A3A3A3"}
                                                                                text={"I have UI/UX Prototype"}/>
                                                                        </Grid>
                                                                        <Grid>

                                                                        </Grid>
                                                                    </Grid>
                                                                </Paper>
                                                            </Grid>
                                                            <Grid item xs={5.5} md={3.5} sx={{marginTop: {xs: "10px", md: "20px"}}}>
                                                                <Paper
                                                                    onClick={(e) => onChangeStep2({target: {value: "mvp"}}, 'project_standing')}
                                                                    sx={{
                                                                        width: "100%",
                                                                        background: "white",
                                                                        padding: {xs: "20px 0px", md: "20px 10px"},
                                                                        borderRadius: "25px",
                                                                        cursor: "pointer",
                                                                        border: step2.project_standing.value === "mvp" && "1px solid #5E17EB"
                                                                    }}>
                                                                    <Grid container alignItems={"center"} direction={"column"}>
                                                                        <Grid item>
                                                                            <Mvp/>
                                                                        </Grid>
                                                                        <Grid item style={{marginTop: "5px"}}>
                                                                            <CustomLabelXSmallBold
                                                                                color={step2.project_standing.value === "mvp" ? "#5E17EB" : "#A3A3A3"}
                                                                                textAlign={"center"}
                                                                                text={"I have a MVP"}/>
                                                                        </Grid>
                                                                        <Grid>

                                                                        </Grid>
                                                                    </Grid>
                                                                </Paper>
                                                            </Grid>
                                                            <Grid item xs={5.5} md={3.5} sx={{marginTop: {xs: "10px", md: "20px"}}}>
                                                                <Paper
                                                                    onClick={(e) => onChangeStep2({target: {value: "development"}}, 'project_standing')}
                                                                    sx={{
                                                                        width: "100%",
                                                                        background: "white",
                                                                        padding: {xs: "20px 0px", md: "20px 10px"},
                                                                        borderRadius: "25px",
                                                                        cursor: "pointer",
                                                                        border: step2.project_standing.value === "development" && "1px solid #5E17EB"
                                                                    }}>
                                                                    <Grid container alignItems={"center"} direction={"column"}>
                                                                        <Grid item>
                                                                            <DevPhase/>
                                                                        </Grid>
                                                                        <Grid item style={{marginTop: "5px"}}>
                                                                            <CustomLabelXSmallBold
                                                                                color={step2.project_standing.value === "development" ? "#5E17EB" : "#A3A3A3"}
                                                                                textAlign={"center"}
                                                                                text={"Development Phase"}/>
                                                                        </Grid>
                                                                        <Grid>

                                                                        </Grid>
                                                                    </Grid>
                                                                </Paper>
                                                            </Grid>
                                                            <Grid item xs={5.5} md={3.5} sx={{marginTop: {xs: "10px", md: "20px"}}}>
                                                                <Paper
                                                                    onClick={(e) => onChangeStep2({target: {value: "launched"}}, 'project_standing')}
                                                                    sx={{
                                                                        width: "100%",
                                                                        background: "white",
                                                                        padding: {xs: "20px 0px", md: "20px 10px"},
                                                                        borderRadius: "25px",
                                                                        cursor: "pointer",
                                                                        border: step2.project_standing.value === "launched" && "1px solid #5E17EB"
                                                                    }}>
                                                                    <Grid container alignItems={"center"} direction={"column"}>
                                                                        <Grid item>
                                                                            <ProjLaunch/>
                                                                        </Grid>
                                                                        <Grid item style={{marginTop: "5px"}}>
                                                                            <CustomLabelXSmallBold
                                                                                color={step2.project_standing.value === "launched" ? "#5E17EB" : "#A3A3A3"}
                                                                                textAlign={"center"}
                                                                                text={"Project is Launched"}/>
                                                                        </Grid>
                                                                        <Grid>

                                                                        </Grid>
                                                                    </Grid>
                                                                </Paper>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                    {step2.project_standing.showError && (
                                                        <FormHelperText error sx={{marginLeft: '10px', marginTop: '5px'}}>
                                                            {step2.project_standing.error}
                                                        </FormHelperText>
                                                    )}
                                                </Grid>

                                                {/* Keep existing navigation buttons */}
                                                <NavigationButtons onBack={() => setProgress(5)} onNext={onSubmitStep2} />
                                            </Grid>
                                        </Grid>
                                    )}

                                    {progress === 45 && (
                                        <Grid container>
                                            <Grid container sx={{marginTop: {xs: "30px", md: "40px"}, marginBottom : {xs: 10 , md : 20}}}>
                                                <Step3Form 
                                                    stage={step2.project_standing.value} 
                                                    data={step3} 
                                                    onChange={onChangeStep3} 
                                                    onSubmit={onSubmitStep3}
                                                />
                                            </Grid>
                                        </Grid>
                                    )}

                                    {progress === 70 && (
                                        <Grid container>
                                            <Grid container sx={{marginTop: {xs: "30px", md: "40px"}, marginBottom : {xs: 10 , md : 20}}}>
                                                <Step4Form 
                                                    stage={step2.project_standing.value}
                                                    data={step4}
                                                    onChange={onChangeStep4}
                                                />
                                                <NavigationButtons onBack={() => setProgress(45)} onNext={onSubmitStep4} />
                                            </Grid>
                                        </Grid>
                                    )}

                                    {progress === 95 && (
                                        <Grid container>
                                            <Grid container sx={{marginTop: {xs: "30px", md: "40px"}, marginBottom : {xs: 10 , md : 30}}}>
                                                {step2.project_standing.value === 'idea' ? (
                                                    // For Idea stage
                                                    <Grid item xs={12} container justifyContent={"flex-start"} style={{marginTop: "20px"}}>
                                                        <Grid item style={{marginLeft: 10}}>
                                                            <CustomLabelXSmallRegular
                                                                text={"Which tech stack or framework do you prefer?"}/>
                                                        </Grid>
                                                        <Grid item container style={{marginTop: 5}}>
                                                            <CustomDropdown
                                                                value={[step5.tech_stack.value]}
                                                                onChange={(e) => onChangeStep5(e, 'tech_stack')}
                                                                error={step5.tech_stack.showError}
                                                                helperText={step5.tech_stack.showError ? step5.tech_stack.error : ""}
                                                                placeholder={"Select tech stack"}
                                                                container={TechStackList}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                ) : (
                                                    // For all other stages
                                                    <Grid item xs={12} container justifyContent={"flex-start"} style={{marginTop: "20px"}}>
                                                        <Grid item style={{marginLeft: 10}}>
                                                            <CustomLabelXSmallRegular
                                                                text={"What are Your Next Steps If This Project Moves Forward?"}/>
                                                        </Grid>
                                                        <Grid item container style={{marginTop: 5}}>
                                                            <CustomTextMultipleField
                                                                value={step5.next_steps.value}
                                                                onChange={(e) => onChangeStep5(e, 'next_steps')}
                                                                error={step5.next_steps.showError}
                                                                helperText={step5.next_steps.showError ? step5.next_steps.error : ""}
                                                                placeholder={"Describe your next steps..."} 
                                                                rows={5}
                                                                otherInputProps={{
                                                                    sx: {
                                                                        '&.MuiOutlinedInput-root': {
                                                                            backgroundColor: "white",
                                                                          },
                                                                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                                            borderColor: '#5E17EB',
                                                                            borderWidth: '1px',
                                                                          },
                                                                        },
                                                                      }}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                )}

                                                {/* Additional Information field (shown for all stages) */}
                                                <Grid item xs={12} container justifyContent={"flex-start"} style={{marginTop: "20px"}}>
                                                    <Grid item style={{marginLeft: 10}}>
                                                        <CustomLabelXSmallRegular
                                                            text={"Additional Information"}/>
                                                    </Grid>
                                                    <Grid item container style={{marginTop: 5}}>
                                                        <CustomTextMultipleField
                                                            value={step5.additional_info.value}
                                                            onChange={(e) => onChangeStep5(e, 'additional_info')}
                                                            error={step5.additional_info.showError}
                                                            helperText={step5.additional_info.showError ? step5.additional_info.error : ""}
                                                            placeholder={"Write something here..."} 
                                                            rows={5}
                                                            otherInputProps={{
                                                                sx: {
                                                                    '&.MuiOutlinedInput-root': {
                                                                        backgroundColor: "white",
                                                                      },
                                                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                                            borderColor: '#5E17EB',
                                                                            borderWidth: '1px',
                                                                          },
                                                                        },
                                                                      }}
                                                        />
                                                    </Grid>
                                                </Grid>

                                                {/* Navigation buttons */}
                                                <Grid item container justifyContent={"center"}
                                                      sx={{paddingBottom: "40px", marginTop: "20px"}}>
                                                    <div>
                                                        <Grid container alignItems={"center"} justifyContent={"center"}
                                                              sx={{
                                                                  border: "1.5px solid #DDDDDD",
                                                                  borderRadius: "20px",
                                                                  padding: {xs: "8px 30px", md: "12px 80px"},
                                                                  background: "white",
                                                                  marginTop: "20px",
                                                                  gap: "5px",
                                                                  cursor: "pointer"
                                                              }}
                                                              onClick={(e) => setProgress(70)}
                                                        >
                                                            <Grid item style={{marginTop: "2px"}}>
                                                                <img src={ARROR_LEFT} alt={"ARROW LEFT"} />
                                                            </Grid>
                                                            <Grid item>
                                                                <CustomLabelSmallMedium text={"Back"} color={"black"}/>
                                                            </Grid>
                                                        </Grid>
                                                    </div>

                                                    <div style={{marginLeft: "20px"}}>
                                                        <Grid container alignItems={"center"} justifyContent={"center"}
                                                              sx={{
                                                                  border: "1.5px solid #F5F5F5",
                                                                  borderRadius: "20px",
                                                                  padding: {xs: "12px 30px", md: "12px 80px"},
                                                                  background: "#5E17EB",
                                                                  marginTop: "20px",
                                                                  gap: "10px",
                                                                  cursor: "pointer"
                                                              }}
                                                              onClick={onSubmitStep5}
                                                        >
                                                            <Grid item>
                                                                <CustomLabelSmallMedium text={"Submit"} color={"white"}/>
                                                            </Grid>
                                                            <Grid item>
                                                                <img src={TICK} alt={"TICK"} />
                                                            </Grid>
                                                        </Grid>
                                                    </div>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    )}
                                </Grid>
                            </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}



export default ProjectByEquity;

